import { render, staticRenderFns } from "./BillsDetail.vue?vue&type=template&id=16ea64b8"
import script from "./BillsDetail.vue?vue&type=script&lang=js"
export * from "./BillsDetail.vue?vue&type=script&lang=js"
import style0 from "./BillsDetail.vue?vue&type=style&index=0&id=16ea64b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports